import React from 'react';
import ContentCard from '../ContentCard';

const DataPrivacyRights = () => {
  return <div className='left-align'>
<ContentCard title="What are the rights of the data subject?" 
  content={
    <>
      <p>Data subjects have the right:</p>
      <ul style={{ marginLeft: '20px' }}>
        <li>to know what personal data we process about them;</li> 
        <li>to request that we rectify inaccurate or incomplete personal data about them;</li> 
        <li>to request that we erase their personal data (e.g., if the data are no longer needed for the purpose or if consent is withdrawn) or request that processing of the personal data be restricted; and</li> 
        <li>to object to specific processing of personal data.</li>
      </ul>

      <p>If you wish to inquire about our personal data processing, raise a complaint, or exercise your rights as described above, please don't hesitate to contact us. You can reach us via email at <a href="mailto:anton@stack-privacy.com">anton@stack-privacy.com</a> or the Contact Page.</p>
    </>
  }
/>

  </div>;
};

export default DataPrivacyRights;